
(function($){
    $('.social-share a').on('click', function(){
        var socialMediaTitle = $(this).attr('title');     
        var socialShareAction = $(this).data('share-action');
        var socialShareUrl    = $(this).data('url');

        if(socialMediaTitle == 'Twitter') {
            socialMediaTitle = petaGA_SNsource_Twitter
        } else if (socialMediaTitle == 'Facebook' ) {
            socialMediaTitle = petaGA_SNsource_Facebook
        } else if ( socialMediaTitle == 'WhatsApp' ) {
            socialMediaTitle = petaGA_SNsource_WhatsApp
        }

        sendSocialEvent(socialMediaTitle, petaGA_GenericAction_Share, socialShareUrl)
        //sendSocialEvent(petaGA_SNsource_Telegram, petaGA_GenericAction_Share, <page URL here>);
    });

})(jQuery);